import {
  GRAY_SCALE_04,
  GRAY_SCALE_05,
  GRAY_SCALE_08,
  PRIMARY_BLUE_02,
} from 'bd-web-components/src/utils/dash-colors'
import styled from 'styled-components'

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 600px;
  @media (max-width: 762px) {
    width: 100%;
  }
`

export const StepInfo = styled.p`
  color: ${PRIMARY_BLUE_02};
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: 0%;
  margin-bottom: 14px;
  @media (max-width: 762px) {
    font-weight: 600;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: 0%;
    margin-bottom: 10px;
  }
`
export const SubInfo = styled.p`
  color: ${GRAY_SCALE_04};
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 26px;
  @media (max-width: 762px) {
    font-weight: 400;
    font-size: 12px;
    line-height: 14.52px;
    letter-spacing: 0%;
    text-align: center;
  }
`

export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`

export const ModalContainerTop = styled.div`
  padding-bottom: 25px;
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid ${GRAY_SCALE_08};
  margin-bottom: 33px;
`

export const ModalContainerBottom = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: space-between;
  justify-content: space-between;
`

export const Space = styled.div`
  width: 10px;
`

export const ModalTitle = styled.h5`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
  }
`

export const ModalSubText = styled.p`
  color: ${GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
